import { PropsWithChildren } from "react";
import styles from "./__styles__/IconText.module.scss";
import Icon, { Props as IconProps } from "./Icons";

const IconText = (props: PropsWithChildren<IconProps>) => (
  <div className={styles.container}>
    <div className={styles.icon}>
      <Icon {...props} />
    </div>
    <div className={styles.text}>{props.children}</div>
  </div>
);

export default IconText;
